import React from "react";
import { Paper, Button } from "@mui/material";

const ItemPresentation = ({ item }) => {
  return (
    <Paper>
      <img
        src={item.reference}
        width="100%"
        height="100%"
        style={{ objectFit: "cover" }}
      />
    </Paper>
  );
};

export default ItemPresentation;
